export const GET_WHATSAPP_NOTIFICATION_SUCCESS = "GET_WHATSAPP_NOTIFICATION_SUCCESS";
export const GET_WHATSAPP_NOTIFICATION_REQUEST = "GET_WHATSAPP_NOTIFICATION_REQUEST";
export const GET_WHATSAPP_NOTIFICATION_FAILURE = "GET_WHATSAPP_NOTIFICATION_FAILURE";
export const getWhatsappNotificationSuccess = (payload) => ({
    type: GET_WHATSAPP_NOTIFICATION_SUCCESS,
    payload,
});
export const getWhatsappNotificationRequest = () => ({
    type: GET_WHATSAPP_NOTIFICATION_REQUEST,
});
export const getWhatsappNotificationFailure = (payload) => ({
    type: GET_WHATSAPP_NOTIFICATION_FAILURE,
    payload,
});
